import { COLORS, pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Table } from 'antd';
import styled from 'styled-components';

export const StyledTable = styled(Table)`
  &&& {
    .ant-table-thead .ant-table-cell,
    .ant-table-column-has-sorters {
      color: ${pickThemeColor('GREY_DIM')};
      background: ${pickThemeColor('GREY_LIGHT')};
      ${pickThemeFontStyles('14', '20', 'SEMI_BOLD')};
      padding: 0.75rem 0.625rem;

      &::before {
        background-color: ${pickThemeColor('GAINSBORO')};
      }
    }

    tr {
      border: none;
      cursor: pointer;
    }

    &&& td {
      border-bottom: none;
      border-right: 1px solid ${COLORS.LIGHT_SILVER};
      border-inline-end: 1px solid ${COLORS.LIGHT_SILVER};
    }

    .ant-table-container {
      border-radius: 0;
      border: 0;
    }

    &&& th {
      border-radius: 0;
      border-right: 1px solid ${COLORS.LIGHT_SILVER};
    }

    &&& th.ant-table-cell {
      border-radius: 0;
      background-color: ${pickThemeColor('GREY_LIGHT')};
      border-right: 1px solid ${COLORS.LIGHT_SILVER};
    }

    .even-row {
      background-color: ${pickThemeColor('WHITE')};
    }
    .odd-row {
      background-color: ${pickThemeColor('LIGHT_WHITE_SMOKE')};
    }

    th.ant-table-column-has-sorters,
    th.ant-table-column-sort {
      color: ${COLORS.WHITE};
      background-color: ${pickThemeColor('GAINSBORO')};
      ${pickThemeFontStyles('14', '20')};
      padding: 0.75rem 0.625rem;

      &::before {
        background-color: ${pickThemeColor('GAINSBORO')};
      }

      .ant-table-column-title {
        color: ${COLORS.WHITE};
      }
    }

    .ant-table-cell {
      color: ${pickThemeColor('BLACK')};
      ${pickThemeFontStyles('16', '20')};
      padding: 0.75rem 1rem;
    }

    .ant-table-bordered {
      background-color: transparent;
    }
  }
` as typeof Table;
